import { TableCard } from '../../../../components'
import { NotaListHeader } from './components/header/NotaListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { NotaTable } from './table/NotaTable'

const NotaList = () => {
  return (
    <TableCard>
      <NotaListHeader />
      <NotaTable />
    </TableCard>
  )
}

export const NotaListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <NotaList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
